import { render, staticRenderFns } from "./settings-dialog.vue?vue&type=template&id=914d007c&"
import script from "./settings-dialog.vue?vue&type=script&lang=js&"
export * from "./settings-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports